import Fuse from 'fuse.js';

const CHOSUNG_LIST = [
  'ㄱ',
  'ㄲ',
  'ㄴ',
  'ㄷ',
  'ㄸ',
  'ㄹ',
  'ㅁ',
  'ㅂ',
  'ㅃ',
  'ㅅ',
  'ㅆ',
  'ㅇ',
  'ㅈ',
  'ㅉ',
  'ㅊ',
  'ㅋ',
  'ㅌ',
  'ㅍ',
  'ㅎ',
];
const HANGUL_START = 0xac00;
const HANGUL_END = 0xd7a3;
const CHOSUNG_INTERVAL = 588;

/**
 * 초성 검색 함수
 * --
 * @param {string} keyword
 * @returns
 */
const handleGetChosung = (keyword) => {
  const NoSplitChosung = keyword
    ?.split('')
    ?.map((char) => {
      const charCode = char.charCodeAt(0);
      if (charCode >= HANGUL_START && charCode <= HANGUL_END) {
        return CHOSUNG_LIST[
          Math.floor((charCode - HANGUL_START) / CHOSUNG_INTERVAL)
        ];
      }
      return char;
    })
    .join('');

  const splitChosung = keyword
    ?.split('')
    ?.map((char) => {
      const charCode = char.charCodeAt(0);
      if (charCode >= HANGUL_START && charCode <= HANGUL_END) {
        return CHOSUNG_LIST[
          Math.floor((charCode - HANGUL_START) / CHOSUNG_INTERVAL)
        ];
      }
      return char;
    })
    .join('')
    .split(' ')
    .join('');

  return {
    NoSplitChosung,
    splitChosung,
  };
};

/**
 * 검색 키워드 찾기
 * --
 * @param {Array} products :
 * @param {string | string[]} keyword string : string[]
 * @returns
 */
export const handleSearchKeyword = (
  products = [], // 검색 배열
  keyword = '', // 검색어
  key = 'title' // 검색키
) => {
  const KEYS = new Set(['NoSplitChosung', 'splitChosung']);

  const replaceKeyword = keyword?.replace(/[\s,]+/g, ''); // 공백과 쉼표 제거

  if (Array.isArray(key)) {
    key.forEach((k) => KEYS.add(k));
  } else {
    KEYS.add(key);
  }
  const newProducts = products?.map((item) => {
    // key가 배열이면 각 키의 값을 가져와서 초성 처리, 문자열이면 그대로 처리
    if (Array.isArray(key)) {
      const newItem = key.reduce((acc, keyItem, keyIndex) => {
        if (!item?.[keyItem]) return acc;
        const { NoSplitChosung, splitChosung } = handleGetChosung(
          item?.[keyItem]
        );
        // console.log(item?.[keyItem]);
        const noSplitKey = `NoSplitChosung_${keyIndex}`;
        const splitKey = `splitChosung_${keyIndex}`;
        KEYS.add(noSplitKey);
        KEYS.add(splitKey);

        return {
          ...acc,
          [noSplitKey]: NoSplitChosung,
          [splitKey]: splitChosung,
        };
      }, {}); // 객체 누적

      return {
        ...item,
        ...newItem, // 배열이 아니라 객체로 추가
      };
      // return n;
    } else {
      return {
        ...item,
        ...handleGetChosung(item?.[key]),
      };
    }
  });
  //검색 라이브러리
  const fuse = new Fuse(newProducts, {
    keys: Array.from(KEYS), //  검색할 필드: 상품명(name) + 초성(chosung)
    threshold: 0.3, //  0에 가까울수록 정확한 검색 (0.3이면 적당한 오타 허용)
    minMatchCharLength: 1, //  최소 몇 글자부터 검색할지 (1글자 이상 입력 시 검색)
    findAllMatches: true, //  모든 일치하는 항목 반환
    useExtendedSearch: true, //  확장 검색 기능 사용 (예: "!"(not), "^"(문장 시작) 등 가능)
    ignoreLocation: true, // 검색어가 어디 있든 검색 가능 (숫자 검색 문제 해결)
    distance: 100, //문자열과 숫자가 섞인 경우 검색 정확도 조절 (기본값: 100)
  });
  const results = replaceKeyword
    ? fuse.search(replaceKeyword).map((res) => res?.item)
    : products;
  return results.sort((a, b) => a.key - b.key);
};
